import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const { verifyEmail } = useAuth();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setError('Missing verification token. Use the link from your email.');
      setDone(true);
      return;
    }
    let cancelled = false;
    (async () => {
      const r = await verifyEmail(token);
      if (cancelled) return;
      setDone(true);
      if (r.success) {
        setMessage('Your email is verified. You can log in.');
      } else {
        setError(r.error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token, verifyEmail]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/tradelensy-logo.png" alt="Tradelensy logo" className="auth-logo" />
          <h1>Tradelensy</h1>
        </div>
        <h2>Email verification</h2>
        {!done && <p style={{ color: '#666' }}>Confirming your email…</p>}
        {message && (
          <div
            style={{
              padding: '12px',
              borderRadius: '4px',
              background: '#d4edda',
              color: '#155724',
              fontSize: '14px',
            }}
          >
            {message}
          </div>
        )}
        {error && <div className="error-message">{error}</div>}
        {done && (
          <p className="auth-link" style={{ marginTop: '20px' }}>
            <Link to="/login">Go to login</Link>
          </p>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
